export const offersFiltersName = {
  specialClassificationFilter: 'specialClassificationFilter',
  producerFilter: 'producerFilter',
  brandFilter: 'brandFilter',
  countryFilter: 'countryFilter',
  wineTypeFilter: 'wineTypeFilter',
  wineColourFilter: 'wineColourFilter',
  sweetnessTypeFilter: 'sweetnessTypeFilter',
  vintageFilter: 'vintageFilter',
  bottleSizeFilter: 'bottleSizeFilter',
  packageTypeFilter: 'packageTypeFilter',
  grapesFilter: 'grapesFilter',
  certificatesFilter: 'certificatesFilter',
  alcoholLevelFilter: 'alcoholLevelFilter',
  wwlRatingFilter: 'wwlRatingFilter',
  deliveryTermsFilter: 'deliveryTermsFilter',
  countryOfShipmentFilter: 'countryOfShipmentFilter',
  minimalBatchFilter: 'minimalBatchFilter',
  exclusiveOffersFilter: 'exclusiveOffersFilter',
  onlyFromProducerFilter: 'onlyFromProducerFilter',
  forCompanyOnlyFilter: 'forCompanyOnlyFilter',
  onlyCompanyFilter: 'onlyCompanyFilter',
  statusFilter: 'statusFilter',
  euGITypeFilter: 'euGITypeFilter',
  nationalGITypeFilter: 'nationalGITypeFilter',
  wineRegionEUFilter: 'wineRegionEUFilter',
  geoIndicationFilter: 'geoIndicationFilter',
  priceFilter: 'priceFilter',
  pricePerLotFilter: 'pricePerLotFilter',
  pricePerBottleFilter: 'pricePerBottleFilter',
  distributionFilter: 'distributionFilter',
  exhibitionFilter: 'exhibitionFilter',
  monocepageFilter: 'monocepageFilter',
  onlyWithOffersFilter: 'onlyWithOffersFilter',
  rrpFilter: 'rrpFilter',
  priceCoefFilter: 'priceCoefFilter',
  rankFilter: 'rankFilter',
  wineOfferTypeDealFilter: 'wineOfferTypeDealFilter',
  buyerCompanyCategoryFilter: 'buyerCompanyCategoryFilter',
  buyerCompanyCountryFilter: 'buyerCompanyCountryFilter',
  sellerCompanyCategoryFilter: 'sellerCompanyCategoryFilter',
  periodOfValidityFilter: 'periodOfValidityFilter',
  firstPublishedAtFilter: 'firstPublishedAtFilter',
  updatedAtFilter: 'updatedAtFilter',
  sellerCompanyUsernameFilter: 'sellerCompanyUsernameFilter',
  buyerCompanyUsernameFilter: 'buyerCompanyUsernameFilter',
  wineOfferTypeFilter: 'wineOfferTypeFilter',
  producerCountryFilter: 'producerCountryFilter',
  emailStatusFilter: 'emailStatusFilter',
  offersCountryFilter: 'producerCountryFilter',
  offersOnlyForMyCompanyFilter: 'offersOnlyForMyCompanyFilter',
  withEmailFilter: 'withEmailFilter',
  daysSinceLastNewsletterFilter: 'daysSinceLastNewsletterFilter',
  stageFilter: 'stageFilter',
  retailPriceFilter: 'retailPriceFilter',
  showLatestVintageFilter: 'showLatestVintageFilter',
  fromShortlistFilter: 'fromShortlistFilter',
  buyerCompanyFilter: 'buyerCompanyFilter',
  hasOffersFilter: 'hasOffersFilter',
  cellarDoorPriceFilter: 'cellarDoorPriceFilter',
  quantityOfItemFilter: 'quantityOfItemFilter',
  marginFilter: 'marginFilter',
  bestOfferPriceFilter: 'bestOfferFilter',
  coefFilter: 'coefFilter',
  minRetailPriceFilter: 'minRetailPriceFilter',
  recommendedRetailPriceFilter: 'rrpFilter',
  hasBottleImageFilter: 'hasBottleImageFilter',
  hasFrontLabelImageFilter: 'hasFrontLabelImageFilter',
  hasBackLabelImageFilter: 'hasBackLabelImageFilter',
  hasVerifiedRepresentativeFilter: 'hasVerifiedRepresentativeFilter',
  havePublicReviewsFilter: 'havePublicReviewsFilter',
  eShopCountryFilter: 'eShopCountryFilter',
  eShopFilter: 'eShopFilter',
  eShopsBrandsFilter: 'eShopsBrandsFilter',
  onlyLowestMerchantPriceFilter: 'onlyLowestMerchantPriceFilter',
  grapeFilter: 'grapeFilter',
} as const

export const offersFiltersTitle = {
  countryFilter: 'filters.names.wineCountryFilter',
  wineTypeFilter: 'filters.names.wineTypeFilter',
  wineColourFilter: 'filters.names.wineColourFilter',
  wineCountryFilter: 'filters.names.wineCountryFilter',
  sweetnessTypeFilter: 'filters.names.sweetnessTypeFilter',
  vintageFilter: 'filters.names.vintageFilter',
  bottleSizeFilter: 'filters.names.bottleSizeFilter',
  packageTypeFilter: 'filters.names.packageTypeFilter',
  grapesFilter: 'filters.names.grapesFilter',
  certificatesFilter: 'filters.names.certificatesFilter',
  alcoholLevelFilter: 'filters.names.alcoholLevelFilter',
  wwlRatingFilter: 'filters.names.wwlRatingFilter',
  deliveryTermsFilter: 'filters.names.deliveryTermsFilter',
  countryOfShipmentFilter: 'filters.names.countryOfShipmentFilter',
  minimalBatchFilter: 'filters.names.minimalBatchFilter',
  exclusiveOffersFilter: 'filters.names.exclusiveOffersFilter',
  onlyFromProducerFilter: 'filters.names.onlyFromProducerFilter',
  forCompanyOnlyFilter: 'filters.names.forCompanyOnlyFilter',
  onlyCompanyFilter: 'filters.names.onlyCompanyFilter',
  statusFilter: 'filters.names.statusFilter',
  euGITypeFilter: 'filters.names.euGITypeFilter',
  nationalGITypeFilter: 'filters.names.nationalGITypeFilter',
  wineRegionEUFilter: 'filters.names.wineRegionEUFilter',
  geoIndicationFilter: 'filters.names.geoIndicationFilter',
  priceFilter: 'filters.names.pricePerBottleFilter',
  pricePerLotFilter: 'filters.names.pricePerLotFilter',
  distributionFilter: 'filters.names.distributionFilter',
  exhibitionFilter: 'filters.names.exhibitionFilter',
  producerCountryFilter: 'filters.names.producerCountryFilter',
  emailStatusFilter: 'filters.names.emailState',
  producerFilter: 'filters.names.producer',
  brandFilter: 'filters.names.brandFilter',
  specialClassificationFilter: 'filters.names.specialClassificationFilter',
  monocepageFilter: 'filters.names.monocepageFilter',
  onlyWithOffersFilter: 'filters.names.onlyWithOffersFilter',
  rrpFilter: 'filters.names.rrp',
  priceCoefFilter: 'filters.names.priceCoef',
  rankFilter: 'filters.names.productRank',
  wineOfferTypeFilter: 'filters.names.wineOfferType',
  buyerCompanyCategoryFilter: 'filters.names.buyerCompanyCategory',
  buyerCompanyCountryFilter: 'filters.names.buyerCompanyCountry',
  sellerCompanyCategoryFilter: 'filters.names.sellerCompanyCategory',
  periodOfValidityFilter: 'filters.names.periodOfValidity',
  firstPublishedAtFilter: 'filters.names.firstPublishedAt',
  updatedAtFilter: 'filters.names.updatedAt',
  sellerCompanyUsernameFilter: 'filters.names.sellerCompanyUsername',
  buyerCompanyUsernameFilter: 'filters.names.buyerCompanyUsername',
  offersOnlyForMyCompanyFilter: 'filters.names.onlyForMyCompFilter',
  withEmailFilter: 'filters.names.withEmail',
  daysSinceLastNewsletterFilter: 'filters.names.noActivity',
  stageFilter: 'filters.names.stage',
  retailPriceFilter: 'filters.names.retailPrice',
  forCompanyFilter: 'filters.names.forCompanyFilter',
  showLatestVintageFilter: 'filters.names.showLatestVintage',
  fromShortlistFilter: 'filters.names.fromShortlist',
  buyerCompanyFilter: 'filters.names.buyerCompany',
  hasOffersFilter: 'filters.names.hasOffers',
  cellarDoorPriceFilter: 'filters.names.recommendedRetailPriceFilter',
  quantityOfItemFilter: 'filters.names.quantityOfItem',
  marginFilter: 'filters.names.margin',
  bestOfferPriceFilter: 'filters.names.bestOffer',
  coefFilter: 'filters.names.coef',
  minRetailPriceFilter: 'filters.names.minRetailPrice',
  recommendedRetailPriceFilter: 'filters.names.recommendedRetailPrice',
  hasBottleImageFilter: 'filters.names.packshot',
  hasFrontLabelImageFilter: 'filters.names.frontLabel',
  hasBackLabelImageFilter: 'filters.names.backLabel',
  hasVerifiedRepresentativeFilter: 'filters.names.hasVerifiedRepresentative',
  havePublicReviewsFilter: 'filters.names.havePublicReviewsFilters',
  retailPriceEshopsFilter: 'filters.names.retailPriceEshops',
  eShopCountryFilter: 'filters.names.eShopCountry',
  eShopFilter: 'filters.names.eShop',
  rrpShortNameFilter: 'filters.names.rrpShortNameFilter',
  eShopsBrandsFilter: 'filters.names.eShopsBrands',
  onlyLowestMerchantPriceFilter: 'filters.names.onlyLowestMerchantPrice',
  grapeFilter: 'filters.names.grapesFilter',
}

export const offersFiltersKey = () => {
  let priceFilter = 'pricePerBottle'

  switch (window.location.pathname.split('/')[2]) {
    case 'buy-wine':
      priceFilter = 'pricePerBottle'
      break
    case 'sell-wine':
      priceFilter = 'price'
      break

    default:
      break
  }

  return {
    countryFilter: 'product.wine.country',
    wineTypeFilter: 'product.wine.wineType',
    wineColourFilter: 'product.wine.wineColor',
    sweetnessTypeFilter: 'product.wine.sweetnessLevel',
    vintageFilter: 'product.wine.vintage',
    bottleSizeFilter: 'bottleSize',
    packageTypeFilter: 'packageType',
    grapesFilter: 'grapeAndMonocepage',
    certificatesFilter: 'product.wine.certification',
    alcoholLevelFilter: 'product.alcoholOnLabel',
    wwlRatingFilter: 'product.wine.rating',
    deliveryTermsFilter: 'incoterms',
    countryOfShipmentFilter: 'countryOfShipment',
    minimalBatchFilter: 'minimumDeliverySize',
    daysSinceLastNewsletterFilter: 'daysSinceLastNewsletter',
    exclusiveOffersFilter: 'exclusive',
    onlyFromProducerFilter: 'onlyFromProducer',
    forCompanyOnlyFilter: 'onlyForMe',
    onlyCompanyFilter: 'onlyCompany',
    statusFilter: 'wineOfferStatus',
    euGITypeFilter: 'product.wine.nationalGIType.euGIType',
    nationalGITypeFilter: 'product.wine.nationalGIType',
    wineRegionEUFilter: 'product.wine.wineRegionEU',
    geoIndicationFilter: 'product.wine.geoIndication',
    priceFilter: priceFilter,
    distributionFilter: 'countryOfDelivery',
    exhibitionFilter: 'exhibition',
    producerCountry: 'product.wine.tradeName.country',
    producerFilter: 'product.wine.tradeName',
    brandFilter: 'product.wine.brand',
    specialClassificationFilter: 'product.wine.specialClassification',
    monocepageFilter: 'grapeAndMonocepage.monocepage',
    rrpFilter: 'product.priceAtWinery',
    priceCoefFilter: 'priceCoefficient',
    rankFilter: 'product.appellationRating.rank',
    wineOfferTypeDealFilter: 'wineOfferTypeDeal',
    sellerCompanyCategoryFilter: 'sellerCompanyCategory',
    buyerCompanyCategoryFilter: 'buyerCompanyCategory',
    buyerCompanyCountryFilter: 'buyerCompanyCountry',
    periodOfValidityFilter: 'periodOfValidity',
    firstPublishedAtFilter: 'firstPublishedAt',
    updatedAtFilter: 'updatedAt',
    sellerCompanyUsernameFilter: 'sellerCompanyUsername',
    buyerCompanyUsernameFilter: 'buyerCompanyUsername',
    buyerCompanyFilter: 'buyerCompanyNameUsernameSecured',
    wineOfferTypeFilter: 'wineOfferType',
    onlyWithOffersFilter: 'onlyWithOffers',
    offersCountryFilter: 'wine.country',
    offersMonocepageFilter: 'wine.monocepage',
    offersProducerFilter: 'wine.tradeName',
    offersBrandFilter: 'wine.brand',
    offersSpecialClassification: 'wine.specialClassification',
    offersVintageFilter: 'wine.vintage',
    offersGrapesFilter: 'wine.grapeVarieties',
    offersCertificatesFilter: 'wine.certification',
    offersAlcoholLevelFilter: 'alcoholOnLabel',
    offersWwlRatingFilter: 'wine.rating',
    offersRrpFilter: 'priceAtWinery',
    offersRankFilter: 'appellationRating.rank',
    offersPriceFilter: 'wineOffers.pricePerBottle',
    offersDeliveryTermsFilter: 'wineOffers.incoterms',
    offersCountryOfShipmentFilter: 'wineOffers.countryOfShipment',
    offersPriceCoefFilter: 'wineOffers.priceCoefficient',
    offersExhibitionFilter: 'wineOffers.exhibition',
    offersMinimalBatchFilter: 'wineOffers.minimumDeliverySize',
    offersOnlyForMyCompanyFilter: 'wineOffers.onlyForMe',
    withEmailFilter: 'onlyWithEmail',
    emailStatus: 'emailStatus',
    stageFilter: 'stage',
    retailPriceFilter: 'tradeOfferLotPricePerBottle',
    showLatestVintageFilter: 'onlyLatestVintage',
    fromShortlistFilter: 'onlyFromCompanyProductShortlist',
    hasOffersFilter: 'hasOffers',
    cellarDoorPriceFilter: 'cellarDoorPrice',
    quantityOfItemFilter: 'activeTradeOfferCount',
    additionalNameFilter: 'product.wine.keywords',
  }
}
